import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import Div from '@/shared/Div';
import React, { ComponentType, Fragment, useEffect, useState } from 'react';
const withLazyLoad = <P extends object>(
  WrappedComponent: ComponentType<P>,
  threshold = 0.5,
): React.FC<P> => {
  // eslint-disable-next-line react/display-name
  return (props: P) => {
    const [isInView, ref] = useIntersectionObserver(threshold);
    const [hasLoaded, setHasLoaded] = useState(false);
    useEffect(() => {
      if (isInView && !hasLoaded) {
        setHasLoaded(true);
      }
    }, [isInView, hasLoaded]);
    return <Div ref={ref}>{hasLoaded ? <WrappedComponent {...props} /> : <Fragment />}</Div>;
  };
};
export default withLazyLoad;
